import React, { useContext, useEffect, useState } from 'react';
import questions from './paceQuestions.json';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import AsyncSelect from 'react-select/async';
import { axiosClient } from '../../../../library/Service/axiosClient';
import { setError } from '../../../../library/Core/SmartFunctions';
import SessionContext from '../../../../library/Core/SessionContext';
import { toast } from 'react-toastify';
import moment from 'moment';

const PaceForm = ({ state, model, userId, isSelfBooking = false }: any) => {
   const { sessionState }: any = useContext(SessionContext);
   const domain = state.domain || new Map();
   console.log("domain",domain.get('FIELD_OF_STUDY_TYPE_CODE_ALUMNI'))

  const studentName = `${model?.firstName || ''} ${model?.lastName || ''}`.trim() || 'Student';
  const studentClass = parseInt(state?.data?.programLevel);;
  console.log("studentClass",studentClass)
  const [formState, setFormState] = useState<Record<string, string | string[]>>({});
  const [savedResponses, setSavedResponses] = useState<Record<string, string | string[]>>({});
  const [showFields, setShowFields] = useState<'all' | 'noResponse'>('all');
  const [lastUpdatedOn, setLastUpdatedOn] = useState<string | null>(null);
  const [lastUpdatedByName, setLastUpdatedByName] = useState<string | null>(null);

  const filteredQuestions = questions.filter((q:any) => q.applicableClasses?.includes(studentClass));

 const handleChange = (id: string, value: string | string[]) => {
    setFormState(prev => {
      const updated = { ...prev };

      const isEmpty =
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0);

      if (isEmpty) {
        delete updated[id]; 
      } else {
        updated[id] = value;
      }

      return updated;
    });
  };

  const fetchPaceData = async () => {
    try {
      const response = await axiosClient().get(
        `${process.env.REACT_APP_BAS_API}/pace/get?studentId=${model?.id}`
      );

      const res = response.data;

      if (res.success && res.data) {
        setFormState(res.data.responses || {});
        setSavedResponses(res.data.responses);
        setLastUpdatedByName(res.data.updatedByName || 'User');
        setLastUpdatedOn(res.data.updatedDate || null);
      }
    } catch (error) {
      console.error('Error fetching PACE form:', error);
    }
  };

  useEffect(() => {
    if (model?.id) {
      fetchPaceData();
    }
  }, [model?.id]);

  const getFormStatus = (formState: Record<string, string | string[]>, studentClass: number, questions: any[]) => {
      const filteredQuestions = questions.filter((q: any) =>
        q.applicableClasses?.includes(studentClass)
      );

      const totalExpectedQuestions = filteredQuestions.reduce((count, q) => {
        if (q.type === 'group' && Array.isArray(q.subQuestions)) {
          return count + q.subQuestions.length;
        }
        return count + 1;
      }, 0);

      const totalAnsweredQuestions = Object.keys(formState).length;

      if (totalAnsweredQuestions === 0) return 'NOT_FILLED';
      if (totalAnsweredQuestions < totalExpectedQuestions) return 'PARTIALLY_FILLED';
      return 'FULLY_FILLED';
    };

  const handleUpdate = async () => {
    const isCounsellor = !isSelfBooking && sessionState?.userTypeCode === 'SUPER_ADMIN' ? 1 : 0;
    const formStatus = getFormStatus(formState, studentClass, questions); 
    console.log("formStatus",formStatus)
    const data = {
      studentId: model?.id,
      responses: formState,
      updatedBy: sessionState?.id,  
      createdBy:sessionState?.id,
      is_counseller:isCounsellor,
      formStatus:formStatus
    };

    try {
      const response = await axiosClient().post(
        `${process.env.REACT_APP_BAS_API}/pace/save`,
        data
      );

      const res = response.data;
      console.log("result",res)
      if (res.success === false) {
          console.warn('Unhandled error:', res.message);
        }else{
           toast.success(res.message);
           await fetchPaceData(); 
        }
    } catch (error) {
      console.error('Save failed:', error);
      alert('Something went wrong while saving. Please try again.');
    }
  };

  const renderWithLabel = (q: any, control: React.ReactNode) => (
    <div className="col-12 mb-4" key={q.id}>
      {!isSelfBooking && (
        <label className="form-label">
          Q: {q.label.replace('{studentName}', studentName)}
        </label>
      )}
      {control}
    </div>
  );

  const renderDropdown = (q: any) => {
    const options = q.domainCategory
      ? domain?.get(q.domainCategory) || []
      : q.options || [];

    const control = (
      <select
        className="form-select"
        value={formState[q.id] || ''}
        onChange={(e) => handleChange(q.id, e.target.value)}
      >
        {q.domainCategory && <option value="">Select</option>}
        {options
          .filter((opt: any) => opt?.value?.trim())
          .map((opt: any, index: number) => (
            <option key={opt.code || `${opt.value}-${index}`} value={opt.code}>
              {opt.value}
            </option>
          ))}
      </select>
    );

    return renderWithLabel(q, control);
  };

  const renderGroup = (q: any) => {
    const groupContent = (
      <div className="row g-3">
        {q.subQuestions.map((sub: any) => {
          let options = sub.domainCategory
            ? domain?.get(sub.domainCategory) || []
            : sub.options || [];

            if (sub.id === 'career1' && formState['career2']) {
              options = options.filter((opt:any) => opt.code !== formState['career2']);
            } else if (sub.id === 'career2' && formState['career1']) {
              options = options.filter((opt:any) => opt.code !== formState['career1']);
            }

          return (
            <div className="col-sm-6" key={sub.id}>
              <label
                  className={
                    isSelfBooking
                      ? 'font-15 list-number'
                      : 'form-label mb-0'
                  }
                >
                  {sub.label}
                </label>
              <select
                className="form-select"
                value={formState[sub.id] || ''}
                onChange={(e) => handleChange(sub.id, e.target.value)}
              >
                {sub.domainCategory && <option value="">Select</option>}
                {options
                  .filter((opt: any) => opt?.value?.trim() !== '')
                  .map((opt: any, index: number) => (
                    <option key={opt.code || `${opt.value}-${index}`} value={opt.code}>
                      {opt.value}
                    </option>
                  ))}
              </select>
            </div>
          );
        })}
      </div>
    );

    return renderWithLabel(q, groupContent);
  };


  const renderMultiSelectDropdown = (q: any) => {
    const options = (q.domainCategory && domain?.get(q.domainCategory)) || [];

    const formattedOptions = options
      .filter((opt: any) => opt?.value?.trim())
      .map((opt: any) => ({
        value: opt.code,
        label: opt.value,
      }));

    const selectedValues = Array.isArray(formState[q.id]) ? formState[q.id] : [];
    const selected = formattedOptions.filter((opt: any) =>
      selectedValues.includes(opt.value)
    );

    const handleSelectChange = (selectedOptions: any) => {
      const values = selectedOptions?.map((opt: any) => opt.value) || [];
      handleChange(q.id, values);
    };

    const loadOptions = (inputValue: string, callback: (options: any[]) => void) => {
      if (!inputValue || inputValue.length < 2) {
        callback([]);
        return;
      }

      const filtered = formattedOptions.filter((opt: any) =>
        opt.label.toLowerCase().includes(inputValue.toLowerCase())
      );

      callback(filtered);
    };

    const control = (
      <AsyncSelect
        isMulti
        cacheOptions
        defaultOptions
        loadOptions={loadOptions}
        onChange={handleSelectChange}
        value={selected}
        isClearable={false}
        styles={customStyles}
        placeholder={q.placeholder || 'Search and select...'}
        // styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        menuPortalTarget={document.body}
      />
    );

    return renderWithLabel(q, control);
  };

 const customStyles = {
    control: (base:any, state:any) => ({
      ...base,
      borderColor: state.isFocused ? '#2684FF' : '#ccc',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
      '&:hover': {
        borderColor: '#2684FF',
      },
      minHeight: '38px',
      flexWrap: 'wrap', 
      overflow: 'visible',
    }),
    valueContainer: (base:any) => ({
      ...base,
      flexWrap: 'wrap',
      maxHeight: 'auto',
      overflowY: 'auto',
    }),
    multiValue: (base:any) => ({
      ...base,
      margin: '2px', 
    }),
    menuPortal: (base:any) => ({ ...base, zIndex: 9999 }),
  };


const renderQuestions = () => (
 
    <div className={` ${isSelfBooking ? '' : 'g-4'}`}>
      {filteredQuestions
        .filter((q: any) => {
          if (showFields === 'all') return true;

          // if (q.type === 'dropdown') {
          //   const value = formState[q.id];
          //   return !(value && String(value).trim() !== '');
          // }

          // if (q.type === 'group' && Array.isArray(q.subQuestions)) {
          //   const hasAnsweredSub = q.subQuestions.some((sub: any) => {
          //     const value = formState[sub.id];
          //     return value && String(value).trim() !== '';
          //   });
          //   return !hasAnsweredSub;
          // }
          if (q.type === 'dropdown') {
            const value = savedResponses[q.id]; 
            return !(value && String(value).trim() !== '');
          }

          if (q.type === 'group' && Array.isArray(q.subQuestions)) {
            const hasAnsweredSub = q.subQuestions.some((sub: any) => {
              const value = savedResponses[sub.id]; 
              return value && String(value).trim() !== '';
            });
            return !hasAnsweredSub;
          }

          return true;
        })
        .map((q: any, index: number) => {
          const label = q.label.replace('{studentName}', studentName);

          const renderStandardControl = () => {
            if (q.type === 'dropdown' && q.multi) return renderMultiSelectDropdown(q);
            if (q.type === 'dropdown') return renderDropdown(q);
            if (q.type === 'group') return renderGroup(q);
            return null;
          };

          if (isSelfBooking) {
            // Just wrap with different UI structure
            return (
              <div className="right text-white pb-3" key={q.id}>
                <p className="font-15 list-number mt-4">
                  <span className="badge badge-pill badge-warning">{index + 1}</span> {label}
                </p>
                {renderStandardControl()}
              </div>
            );
          }

          // For counsellor/admin, return directly
          return renderStandardControl();
        })}
    </div>
 
);


return (
  <>
    {!isSelfBooking ? (
      <>
        <h3 className="font-20 font-500 mb-2">Pace Response</h3>
        <div className="border p-4 radius-6">
          {/* Metadata and filter UI */}
          <div className="row g-4 mb-4">
            <div className="col-sm-6 col-md-4">
              Pace Updated On :
              <span className="d-block font-500">
                {lastUpdatedOn ? moment(lastUpdatedOn).format('DD-MMM-YYYY hh:mm A') : 'Not Available'}
              </span>
            </div>
            <div className="col-sm-6 col-md-4">
              Pace Updated By :
              <span className="d-block font-500">{lastUpdatedByName ?? 'Not Available'}</span>
            </div>

            <div className="col-12">
              <div className="row g-4 align-items-center">
                <div className="col-auto">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="PaceResponse"
                      id="ShowAllFields"
                      checked={showFields === 'all'}
                      onChange={() => setShowFields('all')}
                    />
                    <label className="form-check-label" htmlFor="ShowAllFields">
                      Show All Fields
                    </label>
                  </div>
                </div>

                <div className="col-auto">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="PaceResponse"
                      id="ShowFieldsWithNoResponse"
                      checked={showFields === 'noResponse'}
                      onChange={() => setShowFields('noResponse')}
                    />
                    <label className="form-check-label" htmlFor="ShowFieldsWithNoResponse">
                      Show Fields with no response
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

              {/* Questions rendering */}
              {renderQuestions()}
            </div>
          </>
        ) : (
          <>
            {renderQuestions()}
          </>
        )}

    {/* Show update button in both modes */}
    <div className="col-12 d-flex justify-content-center mt-4">
      <a className="btn btn-primary btn-update" rel="noopener noreferrer" onClick={handleUpdate}>
        {isSelfBooking ? 'Submit' : 'Update'}
      </a>
    </div>
  </>
);

};
export default PaceForm;
